import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { ConfigService } from '../services/config.service';

export const authGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const configService = inject(ConfigService);
  const token = configService.getToken();
  const user = configService.getUser();

  const loginToken = route.queryParams['token'];

  // Delete token from URL after retrieving it
  const currentState = new URL(window.location.href);
  if (currentState.searchParams.has('token')) {
    currentState.searchParams.delete('token');
    window.history.replaceState({}, document.title, currentState.toString());
  }

  // Check if pathname is root, no need redirect
  const finalUrl = new URL(window.location.href);
  const redirectUrl = finalUrl.pathname === '/' ? undefined : `${finalUrl.pathname}${finalUrl.search}`;

  if (loginToken) {
    return true;
  }

  if (!token || !user) {
    router.navigate(['/auth'], { queryParams: { redirect: redirectUrl } });
    return false;
  }
  return true;
};
